import { render, staticRenderFns } from "./AddElementModal.vue?vue&type=template&id=710d8152&"
import script from "./AddElementModal.vue?vue&type=script&lang=js&"
export * from "./AddElementModal.vue?vue&type=script&lang=js&"
import style0 from "./AddElementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports